export const ORDER_STATUS_COLOR_MATCH = Object.freeze({
    1: 'success',
    2: 'info',
    3: 'gray',
    4: 'warning',
    9: 'error',
});

export const ORDER_ITEM_TYPE_MAP = new Map([
    [1, 'fee'],
    [2, 'fee'],
    [3, 'fee'],
    [4, 'fee'],
    [5, 'fee'],
    [6, 'fee'],
    [8, 'product'],
    [11, 'product'],
    [12, 'product'],
    [21, 'fee'],
    [22, 'fee'],
    [51, 'product'],
    [52, 'product'],
]);

export const DATE_TIME_STANDARD = {
    DISPLAYTPFULL: 'YYYY-MM-DDTHH:mm:ss',
    DISPLAYFULL: 'YYYY-MM-DD HH:mm',
    DISPLAYDATE: 'YYYY-MM-DD',
    DISPLAYFULLBYSLASH: 'YYYY/MM/DD HH:mm',
    DISPLAYDATEBYSLASH: 'YYYY/MM/DD',
    DISPLAYDATEOFWEEK: 'YYYY/MM/DD(dd)',
    DISPLAYDATEOFMONTH: 'YYYY/MM',
    DISPLAYTIME: 'HH:mm',
    DISPLAYDATEWITHOUTMINUS: 'YYYYMMDD',
};
